import * as React from 'react';
import { Route } from 'react-router';

import AboutApp from 'bundles/about/components/AboutApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';

const AboutContentfulPage = loadOnRoute(() => import('bundles/about/components/AboutContentfulPage'));

const TermsEnterprisePage = loadOnRoute(() => import('bundles/about/components/TermsEnterprisePage'));
const TermsNonStandardPage = loadOnRoute(() => import('bundles/about/components/TermsNonStandardPage'));
const TermsNonStandardSprintPage = loadOnRoute(() => import('bundles/about/components/TermsNonStandardSprintPage'));
const MobilePage = loadOnRoute(() => import('bundles/about/components/MobilePage'));
const ContactPage = loadOnRoute(() => import('bundles/about/components/ContactPage'));
const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const routes = (
  <Route path="about" component={AboutApp}>
    <Route path="privacy" getComponent={AboutContentfulPage} />
    <Route path="privacy-old" getComponent={AboutContentfulPage} />
    <Route path="privacy/ccpa" getComponent={AboutContentfulPage} />
    <Route path="privacy/data-protection-addendum" getComponent={AboutContentfulPage} />
    <Route path="terms(/:section)" getComponent={AboutContentfulPage} />
    <Route path="terms-old(/:section)" getComponent={AboutContentfulPage} />
    <Route path="terms-for-enterprise" getComponent={TermsEnterprisePage} />
    <Route path="terms-non-standard" getComponent={TermsNonStandardPage} />
    <Route path="terms-non-standard-kpmg" getComponent={TermsNonStandardPage} />
    <Route path="terms-non-standard-sprint" getComponent={TermsNonStandardSprintPage} />
    <Route path="terms-enterprise-content-authoring-addendum" getComponent={AboutContentfulPage} />
    <Route path="mobile" getComponent={MobilePage} />
    <Route path="cookies" getComponent={AboutContentfulPage} />
    <Route path="contact" getComponent={ContactPage} />
    <Route path="live2coursera-terms" getComponent={AboutContentfulPage} />
    <Route path="security" getComponent={AboutContentfulPage} />
    <Route path="*" getComponent={NotFound} />
  </Route>
);

export default routes;
